export default {
  benefit: (state) => state.benefit,
  benefitDistribution: (state) => state.benefitDistribution,
  generatedBenefitCode: (state) => state.benefitCode,
  benefitMovementHistory: (state) => state.benefitMovementHistory,
  metrics: (state) => state.metrics,
}
